import VerticalSliderDesktop from './VerticalSliderDesktop'
export default VerticalSliderDesktop
